import type { AxiosResponse } from "axios";
import api from "./api";
import type { Cliente, CreateCliente } from "../types/cliente";

type LoadClienteOptions = {
  contratante?: boolean;
  contratanteEmpresa?: boolean;
  dependentes?: boolean;
  plano?: boolean;
  assinatura?: boolean;
  empresa?: boolean;
};

const BASE_ROUTE = "/api/v2/app/cliente";

async function load(
  options?: LoadClienteOptions,
  abortController?: AbortController
): Promise<Cliente> {
  try {
    const urlSearchParams = new URLSearchParams();

    if (options) {
      Object.entries(options).map(([key, value]) =>
        urlSearchParams.append(key, value.toString())
      );
    }

    const cliente = await api
      .get<Cliente>(`${BASE_ROUTE}?${urlSearchParams.toString()}`, {
        signal: abortController?.signal,
      })
      .then((response) => response.data);

    return cliente;
  } catch (error: any) {
    return Promise.reject(error);
  }
}

async function cpfExists(
  cpf: string,
  abortController?: AbortController
): Promise<boolean> {
  try {
    await api.get(`${BASE_ROUTE}/verificacao/${cpf}`, {
      signal: abortController?.signal,
    });

    return true;
  } catch (error: any) {
    if (error?.status === 404) {
      return false;
    }

    return Promise.reject(error);
  }
}

async function create(createCliente: CreateCliente): Promise<Cliente> {
  return await api
    .post<Cliente, AxiosResponse<Cliente, CreateCliente>, CreateCliente>(
      BASE_ROUTE,
      createCliente
    )
    .then((response) => response.data);
}

const clienteApi = {
  cpfExists,
  create,
  load,
};

export default clienteApi;
